module.exports = __webpack_public_path__ + "img/RedStar.ab3f35d8.svg";